import React, { Component } from 'react';
import './Header.css';

declare var $;

class Header extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    $(".button-collapse").sideNav();
  }

  render() {
    return (
      <header>
      <div className="navbar-fixed">
          <nav>
           <div className="nav-wrapper">
             <a href="#!" className="brand-logo center"><img src="assets/img/mstch.png" alt=""/></a>
             <a href="#" data-activates="mobile-demo" className="button-collapse"><i className="material-icons">menu</i></a>
           </div>
          </nav>
       </div>
       <ul className="side-nav" id="mobile-demo">
          <li><img src="assets/img/logo-rappi.png"/></li>
          <li><a className="waves-effect waves-light" href="badges.html"> <img src="assets/img/googleplay.png"/>  Google Play</a></li>
          <li><a className="waves-effect waves-light" href="collapsible.html"> <img  className="apple" src="assets/img/appstore.png"/>  App Store</a></li>
          <li><a  className="waves-effect waves-light" href="mobile.html">www.rappi.com</a></li>
          <li><div className="divider"></div></li>
          <li><a className="waves-effect waves-green">Pedir ya!</a></li>
        </ul>
      </header>

    );
  }
}


export default Header;



// WEBPACK FOOTER //
// ./src/components/header/Header.js